<div class="input-date">
  <div class="input-date-input-wrap">
    <input
      id="date-input"
      type="text"
      class="input input-date-input"
      placeholder="{{ placeholder }}"
      fullWidth
      nbInput
      fieldSize="small"
      [ngModel]="date"
      (ngModelChange)="date = $event; chosenDateHandler()"
      [owlDateTimeTrigger]="dynamicFormsDateTime"
      [owlDateTime]="dynamicFormsDateTime">

    <nb-icon
      class="text-pointer input-date-icon"
      [owlDateTimeTrigger]="dynamicFormsDateTime"
      icon="calendar-outline"></nb-icon>
  </div>

  <owl-date-time
    [pickerType]="'calendar'"
    [panelClass]="''"
    [startView]="'month'"
    #dynamicFormsDateTime></owl-date-time>
</div>
